import type { ShearAnchorConnectorSelectionEditDTO } from '@api/fastAPI.schemas'
import { ConnectorSelection } from '../../connectorSelection'

/** The PUT body that gives every location the same Schubverbinder selection. */
export const buildShearAnchorSelectionEdits = (
  locations: ShearAnchorLocationSelection[],
  selection: ConnectorSelection,
): ShearAnchorConnectorSelectionEditDTO[] =>
  locations.map(({ guid, position }) => ({
    segmentId: guid,
    position,
    connectorSelectionPolicy: selection.policy,
    userDefinedConnectorId: selection.connectorId,
  }))
